const tipoPergunta = {
  ABERTA: "Aberta",
  NOTA1A5: "Nota 1 a 5",
};
  
export default tipoPergunta;
  